module.exports = __webpack_public_path__ + "img/progress.632c0023.webp";